export const GET_ZDVL = 'GET_ZDVL';
export const GET_ZDVL_SUCCESS = 'GET_ZDVL_SUCCESS';
export const GET_ZDVL_FAIL = 'GET_ZDVL_FAIL';

export const GET_ZDVL_ACCEPT = 'GET_ZDVL_ACCEPT';
export const GET_ZDVL_ACCEPT_SUCCESS = 'GET_ZDVL_ACCEPT_SUCCESS';
export const GET_ZDVL_ACCEPT_FAIL = 'GET_ZDVL_ACCEPT_FAIL';

export const GET_ZDVL_DECLINE = 'GET_ZDVL_DECLINE';
export const GET_ZDVL_DECLINE_SUCCESS = 'GET_ZDVL_DECLINE_SUCCESS';
export const GET_ZDVL_DECLINE_FAIL = 'GET_ZDVL_DECLINE_FAIL';

export const GET_ZDVL_SEND = 'GET_ZDVL_SEND';
export const GET_ZDVL_SEND_SUCCESS = 'GET_ZDVL_SEND_SUCCESS';
export const GET_ZDVL_SEND_FAIL = 'GET_ZDVL_SEND_FAIL';

export const GET_ZDVL_CLEAR = 'GET_ZDVL_CLEAR';

export const GET_ZDVL_ROLLS = 'GET_ZDVL_ROLLS';
export const GET_ZDVL_ROLLS_SUCCESS = 'GET_ZDVL_ROLLS_SUCCESS';
export const GET_ZDVL_ROLLS_FAIL = 'GET_ZDVL_ROLLS_FAIL';

export const TIE_ZDVL_ROLLS = 'TIE_ZDVL_ROLLS';
export const TIE_ZDVL_ROLLS_SUCCESS = 'TIE_ZDVL_ROLLS_SUCCESS';
export const TIE_ZDVL_ROLLS_FAIL = 'TIE_ZDVL_ROLLS_FAIL';

export const RID_ZDVL_ROLLS = 'RID_ZDVL_ROLLS';
export const RID_ZDVL_ROLLS_SUCCESS = 'RID_ZDVL_ROLLS_SUCCESS';
export const RID_ZDVL_ROLLS_FAIL = 'RID_ZDVL_ROLLS_FAIL';

export const CLOSE_ZDVL = 'CLOSE_ZDVL';
export const CLOSE_ZDVL_SUCCESS = 'CLOSE_ZDVL_SUCCESS';
export const CLOSE_ZDVL_FAIL = 'CLOSE_ZDVL_FAIL';

export const SET_ZDVL_LINE_STATUS_DATA = 'SET_ZDVL_LINE_STATUS_DATA';
export const UPDATE_ZDVL_MODAL_CLOSE = 'UPDATE_ZDVL_MODAL_CLOSE';
export const UPDATE_ZDVL = 'UPDATE_ZDVL';
export const UPDATE_ZDVL_SUCCESS = 'UPDATE_ZDVL_SUCCESS';
export const UPDATE_ZDVL_FAIL = 'UPDATE_ZDVL_FAIL';

export const GET_ZDVL_SEND_NOTICE = 'GET_ZDVL_SEND_NOTICE';
export const GET_ZDVL_SEND_NOTICE_SUCCESS = 'GET_ZDVL_SEND_NOTICE_SUCCESS';
export const GET_ZDVL_SEND_NOTICE_FAIL = 'GET_ZDVL_SEND_NOTICE_FAIL';
